import { render, staticRenderFns } from "./TenantLocations.vue?vue&type=template&id=cd729a70&scoped=true"
import script from "./TenantLocations.vue?vue&type=script&lang=js"
export * from "./TenantLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd729a70",
  null
  
)

export default component.exports